import React from 'react';
import {Container} from "@chakra-ui/react";
import {H2, TextG14} from "../../components/typography";

const Help = () => {
  return (
    <Container>
      <H2 py={6}>Help page</H2>
      <TextG14 py={4}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      </TextG14>
    </Container>
  )
}

export default Help;